// extracted by mini-css-extract-plugin
module.exports = {"projectNavItem":"ProjectNavbar_projectNavItem__2Sljy"};